import tacHelpers from '../../state/tac/tacHelpers';
import productService from '../../services/products';

import Item from '../Item';
import { ITEMS } from '../../constants';
export default class ElvarliShelfDrawer extends Item {
  draw() {
    super.draw();
    const parentIsSection = () => {
      const parent = tacHelpers.getParent(this.app.tac, this.item);
      if (!parent || !parent.itemid) return;
      return (
        parent.filter.type === ITEMS.SECTION_POSTS ||
        parent.filter.type === ITEMS.SECTION_SIDE_UNITS
      );
    };
    if (parentIsSection()) {
      this.sprite.visible = false;
    }
  }

  update(args) {
    super.update(args);
    this.childrenContainer &&
      this.childrenContainer.children.forEach(child => {
        if (child.item && tacHelpers.isPartOf(child.item, this.item)) {
          child.interactive = false;
        }
      });
  }
  sortChildren() {
    this.childrenContainer.children.forEach(child => {
      if (productService.isType(child.item, 'drawer')) {
        child.zIndex = 1;
      } else if (productService.isType(child.item, 'shelf')) {
        child.zIndex = 2;
      }
    });
    this.childrenContainer.sortChildren();
  }

  removeBracketsWhileDragging() {
    this.childrenContainer &&
      this.childrenContainer.children.forEach(child => {
        if (child.item && tacHelpers.isPartOf(child.item, this.item)) {
          child.brackets &&
            Object.values(child.brackets).forEach(
              bracket => (bracket.visible = false)
            );
        }
      });
  }

  updateDependentItemsDragging(newItem, parent) {
    if (!parent.itemid && !newItem.itemid) return;
    this.removeBracketsWhileDragging();
  }
}
